import * as React from 'react';

import { formatDate } from '@acceligentllc/shared/utils/time';

import { NotificationStatusEnum } from '@acceligentllc/shared/enums/notificationStatus';
import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { wrapElementWithTooltip } from 'af-utils/tooltip.util';

import { NOTIFY_MODAL_COL_SPAN } from 'af-constants/values';

interface OwnProps {
	email: string;
	emailInvalidatedAt: Date;
	lastEmailSentAt: Date;
	lastEmailSentStatus: NotificationStatusEnum;
	errorMessage: string;
}

type Props = OwnProps;

export default class EmailStatusInfo extends React.PureComponent<Props> {

	getEmployeeEmailColorApplication = () => {
		const { lastEmailSentStatus } = this.props;

		switch (lastEmailSentStatus) {
			case NotificationStatusEnum.ERROR:
				return 'text-orange';
			case NotificationStatusEnum.OPENED:
				return 'text-green';
			default:
				return '';
		}
	};

	getEmployeeEmailOverlayMessage = () => {
		const { errorMessage, lastEmailSentStatus } = this.props;

		switch (lastEmailSentStatus) {
			case NotificationStatusEnum.ERROR:
				return errorMessage;
			case NotificationStatusEnum.OPENED:
				return 'The participant has opened the link sent in the last email.';
			case NotificationStatusEnum.UNKNOWN:
				return 'Email status is unknown. The participant probably received it, but has not yet opened the supplied link.';
			default:
				return null;
		}
	};

	employeeEmailStatusInfo = (): React.JSX.Element => {
		const { lastEmailSentStatus, emailInvalidatedAt, lastEmailSentAt } = this.props;

		return (
			<>
				{lastEmailSentStatus !== NotificationStatusEnum.SCHEDULED && lastEmailSentAt ? formatDate(lastEmailSentAt, TimeFormat.FULL_DATE) : '-'}
				{lastEmailSentStatus === NotificationStatusEnum.ERROR && emailInvalidatedAt && <span className="icon-info text-red" />}
			</>
		);
	};

	render() {
		return (
			<td className={this.getEmployeeEmailColorApplication()}
				colSpan={NOTIFY_MODAL_COL_SPAN.SEND_TIME}
			>
				{
					wrapElementWithTooltip(
						this.employeeEmailStatusInfo(),
						this.getEmployeeEmailOverlayMessage()
					)
				}
			</td>
		);
	}
}
